import { _js } from '@ifixit/localize';
import * as React from 'react';
import { Bold } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const BoldButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBold().run()}
         isActive={editor.isActive('bold')}
         isDisabled={!editor.can().toggleBold()}
         icon={<Bold />}
         /* Translators: Bold, as in the text formatting */
         title={_js('Bold')}
         shortcut={'b'}
      ></TiptapButton>
   );
};
